export const internAgreementTranslations = {
  lv: {
    pagination: 'Līgumu lapas',
    title: 'Līgumi',
    description:
      'Trīspusējie līgumi par tavām prakses vietām. Paraksta secība: izglītības iestāde, tu, prakses vieta.',
    count_zero: '{{count}} līgumu',
    count_one: '{{count}} līgums',
    count_other: '{{count}} līgumi',
    empty: 'Līgumu vēl nav',
    emptyDescription:
      'Līgums parādīsies šeit, kad izglītības iestāde to sagatavos tavai prakses vietai.',
    agreementNr: 'Līgums {{nr}}',
    hours: '{{hours}} h',
    you: '{{name}} (tu)',
    notYourTurn:
      'Vēl nav tavas kārtas. Vispirms paraksta izglītības iestāde, tad tu, tad prakses vieta. Saņemsi paziņojumu.',
    statuses: {
      toSignEdu: 'Gaida izglītības iestādes parakstu',
      toSignIntern: 'Gaida tavu parakstu',
      toSignOrg: 'Gaida prakses vietas parakstu',
      missingData: 'Līgums tiek sagatavots',
      missingOrg: 'Nav prakses vietas',
      signed: 'Parakstīts',
    },
    parties: {
      Edu: 'Izglītības iestāde',
      Intern: 'Praktikants',
      Org: 'Prakses vieta',
    },
    partyStatus: {
      signed: 'Parakstīts',
      waiting: 'Gaida',
    },
    fields: {
      place: 'Prakses vieta',
      supervisor: 'Prakses vadītājs',
      period: 'Periods',
    },
    actions: {
      signAtEparaksts: 'Parakstīt ar e-parakstu',
      sendToSign: 'Pārsūtīt parakstīšanai',
      download: 'Lejupielādēt',
      uploadSigned: 'Augšupielādēt parakstītu',
    },
    upload: {
      hint: 'Augšupielādē līgumu ar savu parakstu (.edoc vai .asice). Failā jābūt visiem iepriekšējiem parakstiem.',
      file: 'Parakstītais fails',
      fileRequired: 'Izvēlies failu',
      submit: 'Augšupielādēt',
    },
    send: {
      hint: 'Saite līguma parakstīšanai tavā vārdā tiks nosūtīta uz norādīto e-pastu. Saņēmējs to atvērs, ievadot šo pašu e-pastu.',
      email: 'E-pasts',
      emailInvalid: 'Ievadi derīgu e-pasta adresi',
      submit: 'Nosūtīt',
    },
    messages: {
      sent: 'Saite parakstīšanai nosūtīta uz {{email}}.',
      uploaded: 'Parakstītais līgums augšupielādēts.',
      failed: 'Darbība neizdevās.',
      downloadError: 'Neizdevās lejupielādēt līgumu.',
    },
  },
  en: {
    pagination: 'Agreement pages',
    title: 'Agreements',
    description:
      'The three-party agreements for your internship places. Signing order: the educational institution, you, the internship place.',
    count_one: '{{count}} agreement',
    count_other: '{{count}} agreements',
    empty: 'No agreements yet',
    emptyDescription:
      'An agreement appears here once the educational institution prepares it for your internship place.',
    agreementNr: 'Agreement {{nr}}',
    hours: '{{hours}} h',
    you: '{{name}} (you)',
    notYourTurn:
      'It is not your turn yet. The educational institution signs first, then you, then the internship place. You will be notified.',
    statuses: {
      toSignEdu: 'Awaiting the institution’s signature',
      toSignIntern: 'Awaiting your signature',
      toSignOrg: 'Awaiting the internship place’s signature',
      missingData: 'The agreement is being prepared',
      missingOrg: 'No internship place',
      signed: 'Signed',
    },
    parties: {
      Edu: 'Educational institution',
      Intern: 'Intern',
      Org: 'Internship place',
    },
    partyStatus: {
      signed: 'Signed',
      waiting: 'Waiting',
    },
    fields: {
      place: 'Internship place',
      supervisor: 'Supervisor',
      period: 'Period',
    },
    actions: {
      signAtEparaksts: 'Sign with e-signature',
      sendToSign: 'Send for signing',
      download: 'Download',
      uploadSigned: 'Upload signed',
    },
    upload: {
      hint: 'Upload the agreement with your signature (.edoc or .asice). The file must carry every earlier signature.',
      file: 'Signed file',
      fileRequired: 'Choose a file',
      submit: 'Upload',
    },
    send: {
      hint: 'A link to sign the agreement in your name will be sent to this email. The recipient opens it by typing the same email.',
      email: 'Email',
      emailInvalid: 'Enter a valid email address',
      submit: 'Send',
    },
    messages: {
      sent: 'Signing link sent to {{email}}.',
      uploaded: 'The signed agreement was uploaded.',
      failed: 'The action failed.',
      downloadError: 'Could not download the agreement.',
    },
  },
}
